import {
  BillingAccountDetails,
  CryptoTokens,
  Currency,
  DocumentState,
  Invoice,
  InvoicePayableStates,
  InvoiceState,
  NetTerms,
  convertCurrencyToSign,
  convertUnsupportedCurrencyToText,
} from '../../common';
import { PaymentTerms } from '../../common/enums/payment-terms.enum';
import { DUE_UPON_RECEIPT_LABEL } from './generalConstant';
import { getValueWithCurrencySign } from './numbers';

export const getNetTermLabel = (netTerm?: NetTerms) => {
  switch (netTerm) {
    case PaymentTerms.DUE_UPON_RECEIPT:
      return ` (${DUE_UPON_RECEIPT_LABEL})`;
    case PaymentTerms.DUE_UPON_USAGE:
      return '';
    default:
      return ` (${'Net'} ${netTerm})`;
  }
};

export const sum = (arr?: number[]) => arr?.reduce((a, b) => a + b, 0);

export const getPaymentLink = (document: Invoice) => {
  const paymentGatewayByAccount = document.syncStatus?.find(
    (status) => status?.platformName == document?.billingDetails?.paymentGateway?.platform,
  );

  const link = paymentGatewayByAccount?.metadata?.checkoutLink;
  return InvoicePayableStates.includes(document.state as any) && link ? link : undefined;
};

export const isDocumentHasCreditCardPayment = (document: Invoice) => {
  const notAutoCharge = !!document?.billingDetails?.paymentGatewayId;

  const isPaymentFailed =
    document?.billingDetails?.paymentGatewayId && document?.state == DocumentState?.PAYMENT_FAILED;

  return notAutoCharge || isPaymentFailed;
};

export const cryptoTokens = [
  { id: CryptoTokens.USDC, title: 'USDC' },
  { id: CryptoTokens.USDT, title: 'USDT' },
];

const unsupportedCurrencies = [Currency.ILS];

export const handleValueWithNisCurrency = (currency: Currency, value: number) => {
  if (unsupportedCurrencies.includes(currency)) {
    return `${getValueWithCurrencySign(value)} ${convertUnsupportedCurrencyToText(currency)}`;
  }
  return getValueWithCurrencySign(value, convertCurrencyToSign(currency));
};

export const getBankData = (bankDetails?: BillingAccountDetails) => {
  return [
    { key: 'bank', value: bankDetails?.bank, isUpperCase: true },
    { key: 'bankCode', value: bankDetails?.bankCode },
    { key: 'branch', value: bankDetails?.branch },
    { key: 'account', value: bankDetails?.account, isUpperCase: true },
    { key: 'address', value: bankDetails?.address },
    { key: 'routing', value: bankDetails?.routing },
    { key: 'swift', value: bankDetails?.swift },
    { key: 'iban', value: bankDetails?.iban },
  ];
};
